import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { NavBar, Svg, Icon, IconButton, Dropdown } from '../';
import { Button } from 'primereact/button';

function MenuContainer({ children, menuOptions, isReturnEnabled, onClickReturnButton, isSticky, WhiteLabeling }) {

  const { t } = useTranslation('Header');

  return (
    <div id="divMenuContainer" className='layout-menu-container-h' style={{ padding: '10px' }}>
      <div id="menu-children">{children}</div>
    </div>
  );
};

MenuContainer.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  WhiteLabeling: PropTypes.element,
};

MenuContainer.defaultProps = {
  isReturnEnabled: true,
  isSticky: false
};

export default MenuContainer;
